import { checkProjectSettings } from '../../../shared/helpers';

function checkIsDissabledCommentingByAi(project) {
  return checkIsEnabledSwiftGenerationOption(project);
}

function checkIsEnabledSwiftGenerationOption(project) {
  return checkProjectSettings.isSwiftProject(project);
}

export default checkIsDissabledCommentingByAi;
